import { render, staticRenderFns } from "./TriggerTable.vue?vue&type=template&id=18b49e0f&scoped=true&"
import script from "./TriggerTable.vue?vue&type=script&lang=js&"
export * from "./TriggerTable.vue?vue&type=script&lang=js&"
import style0 from "./TriggerTable.vue?vue&type=style&index=0&id=18b49e0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b49e0f",
  null
  
)

export default component.exports